import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Rx'
import { register } from 'store/services/register'
import { alertSuccess, alertErrorDefault } from 'store/ducks/alert'
import { intl } from 'i18n'

// Actions
export const REGISTER_REQUEST = 'register/REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'register/REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'register/REGISTER_FAILURE'

// Reducer
const INITIAL_STATE = {
  signup: {
    loading: false,
    created: false,
    violations: [],
    entity: {},
  },
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case REGISTER_REQUEST:
      return {
        ...state,
        signup: {
          loading: true,
          created: false,
          violations: [],
          entity: {},
        },
      }

    case REGISTER_SUCCESS:
      return {
        ...state,
        signup: {
          loading: false,
          created: true,
          violations: [],
          entity: action.entity,
        },
      }

    case REGISTER_FAILURE:
      return {
        ...state,
        signup: {
          loading: false,
          created: false,
          violations: action.violations || [],
          entity: {},
        },
      }

    default:
      return state
  }
}

// Actions Creators
export const registerRequest = (raw) => ({
  type: REGISTER_REQUEST,
  group: raw.group,
  payload: {
    firstname: raw.firstname,
    lastname: raw.lastname,
    email: raw.email,
    phoneNumber: raw.phone,
    plainPassword: raw.plainPassword,
    managedCompany: {
      name: raw.corporateName,
      vatIdentificationNumber: raw.vatIdentificationNumber,
      streetAddress: raw.streetAddress,
      additionalAddress: raw.additionalAddress,
      postalCode: raw.postalCode,
      city: raw.city,
      country: raw.country,
      sponsorshipCode: raw.sponsorshipCode,
    },
  },
})

export const registerSuccess = (entity) => ({
  type: REGISTER_SUCCESS,
  entity,
})

export const registerFailure = (violations) => ({
  type: REGISTER_FAILURE,
  violations,
})

// Epics
export const epic = combineEpics(registerRequestEpic)

export function registerRequestEpic(action$) {
  return action$.ofType(REGISTER_REQUEST).mergeMap((action) =>
    Observable.ajax(register({ payload: action.payload, params: { group: action.group } }))
      .mergeMap((res) =>
        Observable.of(
          registerSuccess(res.response),
          alertSuccess(intl.formatMessage({ id: 'ducks.register.create.success' })),
        ),
      )
      .catch((res) =>
        Observable.of(registerFailure((res.response || { violations: [] }).violations), alertErrorDefault()),
      ),
  )
}
